import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface RelatedCompaniesTooltipProps {
  openLeft: boolean
}

const RelatedCompaniesTooltip: React.FC<RelatedCompaniesTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            "${relatedCompanies} are any companies associated with the customer. This includes any companies associated with accounts they own, as well as any companies from which they've received budgets or virtual cards. This is not the same as organization membership."
          }
          expressions={{
            relatedCompanies: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Related companies'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default RelatedCompaniesTooltip
